import { type InvocationDataSource } from "./ActionRecord";

export enum TriggerEvaluationCause {
  DatasetMetadataUpdate = "dataset_metadata_update",
  FileUpload = "file_upload",
  FileIngest = "file_ingest",
  FileMetadataUpdate = "file_metadata_update",
  RecurringSchedule = "recurring_schedule",
}

const causeToString: Record<TriggerEvaluationCause, string> = {
  [TriggerEvaluationCause.FileUpload]: "File Uploaded",
  [TriggerEvaluationCause.DatasetMetadataUpdate]: "Dataset Metadata Updated",
  [TriggerEvaluationCause.FileIngest]: "File Ingested",
  [TriggerEvaluationCause.FileMetadataUpdate]: "File Metadata Updated",
  [TriggerEvaluationCause.RecurringSchedule]: "Recurring Schedule",
};

export function causeToFormattedString(cause: TriggerEvaluationCause): string {
  return causeToString[cause];
}

export enum TriggerEvaluationOutcome {
  InvokedAction = "invoked_action",
  Skipped = "skipped",
}

export enum TriggerEvaluationOutcomeReason {
  AlreadyRun = "already_run",
  ConditionNotMet = "condition_not_met",
  NoMatchingFiles = "no_matching_files",
  TriggerDisabled = "trigger_disabled",
}

export enum TriggerEvaluationStatus {
  Pending = "pending",
  Evaluated = "evaluated",
  Failed = "failed",
}

export interface TriggerEvaluationRecord {
  trigger_evaluation_id: number;
  trigger_id: string;
  data_source: InvocationDataSource;
  evaluation_start: string;
  evaluation_end?: string;
  status: TriggerEvaluationStatus;
  status_detail?: string;
  outcome?: TriggerEvaluationOutcome;
  outcome_reason?: TriggerEvaluationOutcomeReason;
  cause?: TriggerEvaluationCause;
}

export interface TriggerEvaluationSummary {
  count_pending: number;
  last_evaluation_start: string | null;
}
